// src/App.js
import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { ApolloProvider } from "@apollo/client";
import SignInSide from "./scenes/Login/LoginPage";
import ChangePasswordForm from "./scenes/users/changepassword";
import Dashboard from "./scenes/dashboard";
import Modules from "./scenes/RoleManagement/Modules";
import Rights from "./scenes/RoleManagement/Rights";
import RoleGroups from "./scenes/RoleManagement/RoleGroup";
import Role from "./scenes/RoleManagement/Roles";
import AssignRight from "./scenes/RoleManagement/Roles/AssignRoleRights";
import AccountAndFinanceModule from "./scenes/AccountsAndFinanceManagement/Accounts";
import Users from "./scenes/users";
import UsersForm from "./scenes/users/users-form";
import { Reduxstore } from "./store/store";
import { Provider } from "react-redux";
// import CourtSetups from "./scenes/Setup Management/CourtSetups/CourtSetups";
import GeographySetups from "./scenes/Setup Management/GeographySetups/GeographySetups";
import LeadSetups from "./scenes/Setup Management/LeadSetups/LeadSetups";
import OtherSetups from "./scenes/Setup Management/OtherSetups/OtherSetups";
import MessageTemplates from "./scenes/Setup Management/MessageTemplates/Template";
import Cases from "./scenes/CaseManagement/Case";
import CaseDetails from "./scenes/Case";
import CorporateClients from "./scenes/clientManagement/corporateClients";
import IndividualClients from "./scenes/clientManagement/individualClients";
import LandingPage from "./scenes/LandingPage";
import CreditNoteList from "./scenes/ClientInvoicing/CreditNote";
// Apollo clients
import {
  createRoleClient,
  createUsersClient,
  createSetupClient,
  createClientManagementClient,
} from "./config";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import withLayout from "./components/HOCApp";
import ChartOfAccounts from "./scenes/AccountsAndFinanceManagement/chartofaccounts";
import { Line, Pie } from "react-chartjs-2";
import BarChart from "./components/BarChart";
import CompanyManagementModule from "./scenes/CompanyManagement/CompanyManagement";
import axios from "axios";
import {
  AbilityContext,
  defineAbilitiesFor,
  transformRoleRights,
} from "./data/RBAC/transformRoleRights";
import PersonDetails from "./scenes/Profile";
import SystemSetups from "./scenes/Setup Management/SystemSetups/SystemSetups";

import Calendar from "./scenes/calendar";
import ForgotPasswordForm from "./scenes/users/ForgotPassword";
import McbSwitch from "./scenes/Login/mcbswitch";
import AdhocMain from "./scenes/adhoc/adhoc";
import SubRightTable from "./scenes/RoleManagement/SubRight";
import CasesByCorporateClients from "./scenes/clientManagement/corporateClients/CaseByClient";
import LeaveApplicationsTable from "./scenes/HRManagemenet/LeaveApplications";
import HRSetups from "./scenes/HRManagemenet/setups/tab";
import LeaveApprovalsTable from "./scenes/HRManagemenet/LeaveApprovals";
import StaffClaimsTable from "./scenes/HRManagemenet/StaffClaim";
import StaffClaimsByUserTable from "./scenes/HRManagemenet/StaffClaimByUser";
import ImprestApproversTable from "./scenes/HRManagemenet/setups/ImprestApprovers";
import ImprestApplicationsByUserTable from "./scenes/HRManagemenet/ImprestByUser";
import { imprestApplications } from "./data/Queries/HRmanagement/leavemanagement";
import ImprestSurrenderTable from "./scenes/HRManagemenet/ImprestSurrender/surrendar";
import StaffClaimsLinesTable from "./scenes/HRManagemenet/StaffClaimByUser/staffClaimLines";
import ImprestSurrenderLineTable from "./scenes/HRManagemenet/ImprestSurrender/surrenderline";
import CasesByIndividualClients from "./scenes/clientManagement/individualClients/casesByClients";
import RelieversByApplicationId from "./scenes/HRManagemenet/LeaveApplications/Relievers";
import PettyCashTab from "./scenes/HRManagemenet/PettyCash/tab";
import HorizontalTab from "./scenes/HRManagemenet/HorizontalTab";
import ReportBrowser from "./scenes/reports/ReportBrowser";
import MajorClassification from "./scenes/reports/MajorClassification";
import ReportTypes from "./scenes/reports/ReportTypes";
import MinorClassification from "./scenes/reports/MinorClassification";
import FeeNote from "./scenes/ClientInvoicing/FeeNote";
import PurchaseInvoice from "./scenes/ClientInvoicing/PurchaseInvoice";
import DebtorsListTable from "./scenes/AccountsAndFinanceManagement/Tables/Debtors";
import ProformaNoteList from "./scenes/ClientInvoicing/Proforma";
import ClientReceiptList from "./scenes/ClientInvoicing/ClientReceipts";
import ProformaLines from "./scenes/ClientInvoicing/Proforma/ProformaLines";
import Proforma from "./scenes/ClientInvoicing/Proforma";
//mport VendorInvoice from "./scenes/ClientInvoicing/VendorInvoice";
//import DebtorsListTable from "./scenes/AccountsAndFinanceManagement/Tables/Debtors";
import FeeNoteLines from "./scenes/ClientInvoicing/FeeNote/FeeNoteLines";
import ClientReceipLines from "./scenes/ClientInvoicing/ClientReceipts/ClientReceiptLines";
import ChartOfAccountsTable from "./scenes/AccountsAndFinanceManagement/Component/ChartOfAccountsTable";
import VoucherHeader from "./scenes/SupplierInvoicing/PaymentVoucher/VoucherHeader";
import VoucherLinesTable from "./scenes/SupplierInvoicing/Lines";
import PurchaseInvoiceLines from "./scenes/ClientInvoicing/PurchaseInvoice/PurchaseInvoiceLines";
import CreditNoteLines from "./scenes/ClientInvoicing/CreditNote/CreditNoteLines";
import EmployeesTable from "./scenes/HRManagemenet/EmployeeManagement";
import AssetsTypes from "./scenes/FixedAssetsManagement/AssetSetups/assetsTypes";
import FixedAssetsCategories from "./scenes/FixedAssetsManagement/AssetSetups/fixedAssetsCategories";
import DepreciationMethods from "./scenes/FixedAssetsManagement/AssetSetups/depreciationMethods";
import DepreciationSchedules from "./scenes/FixedAssetsManagement/AssetSetups/DepreciationSchedules";
import AssetSetups from "./scenes/FixedAssetsManagement/AssetSetups/tab";
import FixedAssets from "./scenes/FixedAssetsManagement/FixedAssets";
import ImprestApplicationLines from "./scenes/HRManagemenet/ImprestByUser/imprestLine";
import ClaimApplicationLines from "./scenes/HRManagemenet/StaffClaimByUser/staffClaimLines";
import PayrollTable from "./scenes/HRManagemenet/Payroll";
import PayrollRunLines from "./scenes/HRManagemenet/Payroll/PayrollRun/PayrollRunLines";
import StatutoryRateTable from "./scenes/HRManagemenet/PayrollSetups/StatutoryRate/StatutoryRate";
import { Suppliers } from "./scenes/AccountsAndFinanceManagement/Component/Components";
import SuppliersTable from "./scenes/AccountsAndFinanceManagement/Tables/Suppliers";
import BanksAccountTable from "./scenes/AccountsAndFinanceManagement/Tables/BankAccounts";



const setupcaseclient = new ApolloClient({
  uri: "https://localhost:7266/graphql/",
  cache: new InMemoryCache(),
});

let hasRefreshed = false;

function App() {
  const userManagementClient = createUsersClient();
  const roleManagementClient = createRoleClient();
  const clientManagementClient = createClientManagementClient();
  const setupManagementClient = createSetupClient();
  const navigate = useNavigate();
  const location = useLocation();
  const [theme, colorMode] = useMode();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = localStorage.getItem("token");
      const expirationTime = localStorage.getItem("tokenExpiration");
      const currentTime = new Date().getTime();

      if (
        !token ||
        !expirationTime ||
        currentTime > parseInt(expirationTime, 10)
      ) {
        // Token is missing or expired, log out the user
        if (
          location.pathname === "/forgot-password" ||
          location.pathname === "/"
        ) {
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("tokenExpiration");
          setIsAuthenticated(false);
          navigate("/Login");
        }
      }
    };

    const interval = setInterval(checkTokenExpiration, 60000); // Check every minute

    // Initial check when component mounts
    checkTokenExpiration();

    return () => clearInterval(interval);
  }, [navigate, setIsAuthenticated, location.pathname]);

  const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes
  useEffect(() => {
    let inactivityTimer;

    const resetInactivityTimer = () => {
      if (inactivityTimer) {
        clearTimeout(inactivityTimer);
      }
      inactivityTimer = setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("tokenExpiration");
        localStorage.clear();
        setIsAuthenticated(false);
        navigate("/Login");
      }, INACTIVITY_LIMIT);
    };

    const handleActivity = () => {
      resetInactivityTimer();
    };

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);

    resetInactivityTimer(); // Initialize timer

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      if (inactivityTimer) {
        clearTimeout(inactivityTimer);
      }
    };
  }, [navigate]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAuthenticated(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  // axios.interceptors.request.use(
  //   (config) => {
  //     const unformatedtoken = localStorage.getItem("token");
  //     const token = unformatedtoken ? unformatedtoken.replace(/"/g, "") : null;
  //     if (token) {
  //       config.headers.Authorization = `Bearer ${token}`;
  //     }
  //     return config;
  //   },
  //   (error) => Promise.reject(error)
  // );
  // axios.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     if (error.response && error.response.status === 401 && !hasRefreshed) {
  //       const isLoginPage =
  //         window.location.pathname === "/Login" ||
  //         window.location.pathname === "/MCB-SWITCH";
  //       if (!isLoginPage) {
  //         hasRefreshed = true;
  //         window.location.reload();
  //       }
  //     }
  //     return Promise.reject(error);
  //   }
  // );
  return (
    <ColorModeContext.Provider value={colorMode}>
      {/* <Provider store={Reduxstore}> */}
      <ThemeProvider theme={theme}>
        <Box data-theme={theme.palette.mode} sx={{ minHeight: "100vh" }}>
          <CssBaseline />{" "}
          <ApolloProvider client={userManagementClient}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route
                path="/Login"
                element={<SignInSide onLogin={() => setIsAuthenticated(true)} />}
              />
              <Route path="/changepassword" element={<ChangePasswordForm />} />
              <Route path="/forgot-password" element={<ForgotPasswordForm />} />
              <Route path="/profile" element={withLayout(PersonDetails)()} />
              <Route path="/MCB-SWITCH" element={<McbSwitch />} />
            </Routes>
          </ApolloProvider>
          {isAuthenticated && (
            <>
              <ApolloProvider client={roleManagementClient}>
                <Routes>
                  <Route path="/module" element={withLayout(Modules)()} />
                  <Route path="/rights" element={withLayout(Rights)()} />
                  <Route path="/role-group" element={withLayout(RoleGroups)()} />
                  <Route path="/role" element={withLayout(Role)()} />
                  <Route path="/subright" element={withLayout(SubRightTable)()} />
                  <Route
                    path="/role-Rights"
                    element={withLayout(AssignRight)()}
                  />
                  <Route
                    path="/accounts-setups"
                    element={withLayout(AccountAndFinanceModule)()}
                  />
                </Routes>
              </ApolloProvider>
              <ApolloProvider client={userManagementClient}>
                <Routes>
                  <Route path="/users" element={withLayout(Users)()} />
                  <Route path="/usersform" element={withLayout(UsersForm)()} />
                </Routes>
              </ApolloProvider>
              {/* leave management */}
              <Routes>
                <Route
                  path="/leave-approvals"
                  element={withLayout(LeaveApprovalsTable)()}
                />
                <Route
                  path="/suppliers"
                  element={withLayout(SuppliersTable)()}
                />
                <Route
                  path="/BankAccounts"
                  element={withLayout(BanksAccountTable)()}
                />
                <Route
                  path="/leave-applications"
                  element={withLayout(HorizontalTab)()}
                />
                <Route
                  path="/staff-claims"
                  element={withLayout(HorizontalTab)()}
                />
                <Route
                  path="/Payroll"
                  element={withLayout(HorizontalTab)()}
                />
                <Route
                  path="/payroll-setups"
                  element={withLayout(HorizontalTab)()}
                />
                <Route
                  path="/employee-details"
                  element={withLayout(HorizontalTab)()}
                />
                 <Route
                  path="/case-setup"
                  element={withLayout(HorizontalTab)()}
                />
                <Route
                  path="/payrollrun-lines"
                  element={withLayout(PayrollRunLines)()}
                />
                <Route
                  path="/statutory-rates"
                  element={withLayout(StatutoryRateTable)()}
                />
                <Route
                  path="/staff-claim-approvals"
                  element={withLayout(StaffClaimsTable)()}
                />

                {/* <Route
                path="/Imprest-Surrender"
                element={withLayout(ImprestSurrenderTable)()}
              /> */}
                <Route
                  path="/imprest-applications"
                  element={withLayout(HorizontalTab)()}
                />
                <Route
                  path="/imprest-lines"
                  element={withLayout(ImprestApplicationLines)()}
                />
                <Route
                  path="/claim-lines"
                  element={withLayout(ClaimApplicationLines)()}
                />
                <Route
                  path="/proforma-fee-note-lines"
                  element={withLayout(ProformaLines)()}
                />
                <Route
                  path="/fee-note-lines"
                  element={withLayout(FeeNoteLines)()}
                />
                <Route
                  path="/credit-note-lines"
                  element={withLayout(CreditNoteLines)()}
                />
                <Route
                  path="/purchase-invoice-lines"
                  element={withLayout(PurchaseInvoiceLines)()}
                />

                <Route
                  path="/client-receipt-lines"
                  element={withLayout(ClientReceipLines)()}
                />
                <Route
                  path="/staff-claim-Lines"
                  element={withLayout(StaffClaimsLinesTable)()}
                />
                <Route
                  path="/relievers"
                  element={withLayout(RelieversByApplicationId)()}
                />
                <Route path="/petty-cash" element={withLayout(PettyCashTab)()} />
                <Route
                  path="/imprest-Surrender-Lines"
                  element={withLayout(ImprestSurrenderLineTable)()}
                />
              /* fixed asset management */
                <Route path="/asset-set-up" element={withLayout(HorizontalTab)()} />
                <Route path="/fixed-asset" element={withLayout(FixedAssets)()} />
                <Route path="/hr-setups" element={withLayout(HRSetups)()} />
              </Routes>
              <ApolloProvider client={setupManagementClient}>
                <Routes>
                  <Route path="/Lead" element={withLayout(LeadSetups)()} />
                  <Route
                    path="/Geography"
                    element={withLayout(GeographySetups)()}
                  />
                  <Route
                    path="/othersetups"
                    element={withLayout(OtherSetups)()}
                  />
                  <Route
                    path="/account-classification"
                    element={withLayout(ChartOfAccounts)()}
                  />
                  <Route
                    path="/debtors-list"
                    element={withLayout(DebtorsListTable)()}
                  />
                  <Route
                    path="/manage-companies"
                    element={withLayout(CompanyManagementModule)()}
                  />
                  <Route
                    path="/messagetemplates"
                    element={withLayout(MessageTemplates)()}
                  />
                  <Route
                    path="/systemsetups"
                    element={withLayout(SystemSetups)()}
                  />
                </Routes>
              </ApolloProvider>
              <ApolloProvider client={setupcaseclient}>
                <Routes>
                  <Route path="/Cases" element={withLayout(Cases)()} />
                  <Route path="/diaries" element={withLayout(Calendar)()} />
                  <Route
                    path="/case-details"
                    element={withLayout(CaseDetails)()}
                  />
                  <Route
                    path="/Corporate-Client-Cases"
                    element={withLayout(CasesByCorporateClients)()}
                  />
                  <Route
                    path="/Individual-Client-Cases"
                    element={withLayout(CasesByIndividualClients)()}
                  />
                </Routes>
              </ApolloProvider>
              <ApolloProvider client={clientManagementClient}>
                <Routes>
                  <Route
                    path="/corporate-clients"
                    element={withLayout(CorporateClients)()}
                  />
                  <Route
                    path="/individual-clients"
                    element={withLayout(IndividualClients)()}
                  />
                </Routes>
              </ApolloProvider>
              <Routes>
                <Route path="/bar" element={withLayout(BarChart)()} />
                <Route
                  path="/super-admin-dashboard"
                  element={withLayout(Dashboard)()}
                />
                <Route path="/adhoc" element={withLayout(AdhocMain)()} />
              </Routes>
              {/* Reports  */}
              <Routes>
                <Route
                  path="/reports-major-classification"
                  element={withLayout(MajorClassification)()}
                />
                <Route
                  path="/chartOfAccounts"
                  element={withLayout(ChartOfAccountsTable)()}
                />
                <Route
                  path="/feenote"
                  element={withLayout(HorizontalTab)()} />
                <Route
                  path="/vendor-invoice"
                  element={withLayout(PurchaseInvoice)()}
                />
                <Route
                  path="/Proforma"
                  element={withLayout(ProformaNoteList)()}
                />
                {/* <Route
                path="/proforma-LINE"
                element={withLayout(Proforma)()}
              /> */}
                <Route
                  path="/client-receipts"
                  element={withLayout(ClientReceiptList)()}
                //element={withLayout(Proforma)()}
                />
                {/* <Route
                path="/imprest-applications"
                element={withLayout(ImprestApplicationsByUserTable)()}
              /> */}
                <Route
                  path="/payment-voucher"
                  element={withLayout(VoucherHeader)()}
                />
                <Route
                  path="/payment-voucher-lines"
                  element={withLayout(VoucherLinesTable)()}
                />

                <Route
                  path="/reports-minor-classification"
                  element={withLayout(MinorClassification)()}
                />
                <Route path="/report-types" element={withLayout(ReportTypes)()} />
                <Route
                  path="/reports-browser"
                  element={withLayout(ReportBrowser)()}
                />
                <Route
                  path="/CreditNote"
                  element={withLayout(CreditNoteList)()}
                />
                {/* Employee management */}
                <Route path="/employees"
                  element={withLayout(EmployeesTable)()} />
              </Routes>
            </>
          )}
          <Routes>
            <Route path="/signin" element={<SignInSide />} />
          </Routes>
        </Box>
      </ThemeProvider>
      {/* </Provider> */}
    </ColorModeContext.Provider >
  );
}

export default App;
